import { Middleware, MiddlewareAPI } from "redux";
import { Action, AnyAction } from "typescript-fsa";

import { Commands, Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import {
	FormEngineActions,
	FormEngineSelectors
} from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";

import { acceptEditAntragAction, editAntragAction } from "../../processFormEngine/sagas/actions";
import { ANTRAG_DETAIL_ACTIVITY_ID, TASK_DETAIL_ACTIVITY_ID } from "../../processOverview/store/actions";

function isCorrectionModeAction(action: AnyAction): action is Action<{
	readonly activityId: string;
	readonly engineEvent: Action<Events.EventButtonPayload>;
}> {
	return (
		FormEngineActions.command.match(action) &&
		Commands.CorrectionMode.setCorrectionModeBackup.match(action.payload.engineEvent)
	);
}

/**
 * This function intercepts the correction mode. The function call next(action) is only called if:
 * - The current action is not a correction mode action.
 * - The activity id from the payload is not ANTRAG_DETAIL_ACTIVITY_ID or TASK_DETAIL_ACTIVITY_ID.
 * If the activity id is ANTRAG_DETAIL_ACTIVITY_ID or TASK_DETAIL_ACTIVITY_ID, then do nothing except if:
 * - The activity id is ANTRAG_DETAIL_ACTIVITY_ID and the activity is readonly, then dispatch editAntragAction.
 * - The activity id is TASK_DETAIL_ACTIVITY_ID and the activity is readonly, then dispatch acceptEditAntragAction.
 */
export const handleCorrectionModeActionMiddleware: Middleware<unknown> = api => next => {
	return action => {
		if (!isCorrectionModeAction(action)) {
			return next(action);
		}

		if (action.payload.activityId === ANTRAG_DETAIL_ACTIVITY_ID) {
			if (isReadonlyMode(ANTRAG_DETAIL_ACTIVITY_ID, api)) {
				return api.dispatch(editAntragAction({ activityId: ANTRAG_DETAIL_ACTIVITY_ID }));
			}
			return { type: "DO_NOTHING_DUMMY" };
		}

		if (action.payload.activityId === TASK_DETAIL_ACTIVITY_ID) {
			if (isReadonlyMode(TASK_DETAIL_ACTIVITY_ID, api)) {
				return api.dispatch(acceptEditAntragAction({ activityId: ANTRAG_DETAIL_ACTIVITY_ID }));
			}
			return { type: "DO_NOTHING_DUMMY" };
		}

		return next(action);
	};
};

function isReadonlyMode(activityId: string, api: MiddlewareAPI): boolean {
	const uiState = FormEngineSelectors.uiState(activityId)(api.getState());
	return uiState?.readonly != undefined ? uiState.readonly : false;
}
